import { useMemo } from 'react';

import { useLearnerCourseHref } from '@/features/course/learner/hooks/useLearnerCourseNavigate';
import { useLearningJourneyBreadcrumbs } from '@/store/v2/journeys/useLearningJourneyBreadcrumbs';

export const useBackToJourneyHref = (options: { id: number; isProduct?: boolean }): string => {
  const href = useLearnerCourseHref();
  const breadcrumbs = useLearningJourneyBreadcrumbs({
    id: options.id,
    isProduct: options.isProduct,
  });

  return useMemo(() => {
    if (!breadcrumbs) {
      return '';
    }
    const { journeyId, journeyTitle, parentSectionId } = breadcrumbs;
    return parentSectionId
      ? href.courseLearningJourneySectionPage({
          journeyId,
          sectionId: parentSectionId,
          journeyTitle,
        })
      : href.courseLearningJourneyPage({
          id: journeyId,
          title: journeyTitle,
        });
  }, [breadcrumbs, href]);
};
